module.exports = __webpack_public_path__ + "static/media/elcetricComponents.11be44a3.svg";